import request from '@/utils/request';

export function doPay(data) {
	return request({
		url: 'pay/dopay',
		method: 'post',
		data,
	});
}

export function getUserInte() {
	return request({
		url: 'pay/inte',
		method: 'get',
		is_cancel_require: true,
	});
}

